import React from 'react';
import AppBar from './AppBar';
import DxMenu from './DxMenu';

const DxAppBar = (props) => (
  <AppBar {...props} userMenu={<DxMenu {...props} />} />
);

export default DxAppBar;
